import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { faX, faTrash, faPlus,faCartShopping, faMinus, faAngleDown, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { CategoryService } from 'src/app/services/category/category.service';
import { LoginComponent } from 'src/app/components/modals/login/login.component';
import { Subscription } from 'rxjs';
import { ProductAddedToCartComponent } from '../modals/product-added-to-cart/product-added-to-cart.component';

@Component({
  selector: 'app-cart-sidebar',
  templateUrl: './cart-sidebar.component.html',
  styleUrls: ['./cart-sidebar.component.scss']
})
export class CartSidebarComponent {
  @Output() closeCart = new EventEmitter<void>();
  faX = faX;
  faCartShopping = faCartShopping;
  faTrash = faTrash;
  faMinus = faMinus;
  faPlus = faPlus;
  faAngleDown = faAngleDown;
  faUser = faUserCircle;
  faTrashCan = faTrashCan;
  cartOpen: boolean = false;
  modalCarga?: NgbModalRef;
  cartItems: any[] = [];
  totalItems: number = 0;
  totalAmount: number = 0;
  subtotalAmount: number = 0;
  totalDiscount: number = 0;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  isLoggedIn: boolean = false;
  userName: string = '';
  private loginSubscription: Subscription | undefined;

  @ViewChildren('cartItem') cartItemElements!: QueryList<ElementRef<HTMLElement>>;

  constructor(
    private categoryService: CategoryService,
    private cartService: CartService,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthService
  ) {}
  ngOnInit(): void {
    this.loginSubscription = this.authService.loginSuccess$.subscribe(() => {
      this.updateHeader(); 
    });
    this.cartService.totalItems$.subscribe(count => {
      this.totalItems = count;
    });

    this.cartItems = this.cartService.getCartItems();
    this.updateTotalAmount();
    this.cartService.totalItems$.subscribe(() => {
      this.cartItems = this.cartService.getCartItems();
       this.updateTotalAmount();
    });

    this.checkLoginStatus();
  }
  updateHeader(): void {
    this.checkLoginStatus();
  }
  toggleCart(): void {
    this.closeCart.emit();
  }
  checkLoginStatus(): void {
    const userData = this.authService.getUserData();
    if (userData) {
      this.isLoggedIn = true;
      this.userName = userData.data_user.name;
    } else {
      this.isLoggedIn = false;
      this.userName = '';
    }
  }
  clearCart(): void {
    this.modalCarga = this.modalService.open(ProductAddedToCartComponent, this.ngbModalOptions);
    this.modalCarga.componentInstance.title = "¡Atención!";
    this.modalCarga.componentInstance.description = "Estás a punto de vaciar tu carrito de compras. Al continuar con el proceso perderás los productos seleccionados.";
    this.modalCarga.componentInstance.textFirstButton = 'Vaciar';
    this.modalCarga.componentInstance.textSecondButton = 'Cancelar';
    this.modalCarga.componentInstance.firstButtonAction = () => {
      this.cartService.clearCart(); // Llama al método clearCart del servicio
      this.updateTotalAmount(); // Actualiza el total
    };
    this.modalCarga.componentInstance.secondButtonAction = () => {
      this.modalCarga.close('close');
    };
    this.modalCarga.result.then((data: any) => {
     
    });
  }
  increaseQuantity(item: any): void {
    item.quantity++;
    if(item.quantity > item.maxQuantity){
      item.quantity = item.maxQuantity;
    }
    this.cartService.saveCartToStorage();
    this.updateTotalAmount();
  }
  removeItem(item: any): void {
    this.modalCarga = this.modalService.open(ProductAddedToCartComponent, this.ngbModalOptions);
    this.modalCarga.componentInstance.title = "¡Atención!";
    this.modalCarga.componentInstance.description = "Estás a punto de eliminar este producto de tu carrito de compras ¿deseas continuar con el proceso?";
    this.modalCarga.componentInstance.textFirstButton = 'Eliminar';
    this.modalCarga.componentInstance.textSecondButton = 'Cancelar';
    this.modalCarga.componentInstance.firstButtonAction = () => {
      this.cartService.removeFromCart(item._id, item.color, item.size);
      this.updateTotalAmount();
    };
    this.modalCarga.componentInstance.secondButtonAction = () => {
      this.modalCarga.close('close');
    };
    this.modalCarga.result.then((data: any) => {
     
    });
    
  }
  decreaseQuantity(item: any): void {
    if (item.quantity > 1) {
      item.quantity--;
      this.cartService.saveCartToStorage();
      this.updateTotalAmount();
    }
  }
  updateTotalAmount(): void {
    if (this.cartItems && this.cartItems.length > 0) {
      this.subtotalAmount = this.cartItems.reduce((total, item) => {
        const basePrice = item?.previousPrice > 0 ? item.previousPrice : item.price;
        return total + (basePrice * item.quantity);
      }, 0);
      
      const totalWithDiscount = this.cartItems.reduce((total, item) => {
        return total + (item.price * item.quantity);
      }, 0);
      
      this.totalDiscount = Math.max(0, this.subtotalAmount - totalWithDiscount);
      this.totalAmount = totalWithDiscount;
    } else {
      this.totalAmount = 0;
    }  }
  checkout(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home/checkout']);
    } else {
      this.modalCarga = this.modalService.open(LoginComponent, this.ngbModalOptions);
      this.modalCarga.result.then((data: any) => {
        if(data === 'login'){
          this.router.navigate(['/home/checkout']);
        }
        if(data === 'register'){
          
        }
        this.checkLoginStatus();
      }, () => {
        this.checkLoginStatus();
      });
    }
  }
  
  validateQuantity(item: any): void {
    // Convertir a número y luego a entero
    const quantity = parseInt(item.quantity, 10);
    let currentInput = this.getCartItemInputById(item._id);
    
    if (!isNaN(quantity) && quantity >= 1) {
      item.quantity = quantity;
      if(item.quantity > item.maxQuantity){
        item.quantity = item.maxQuantity;
      }
      currentInput.value = item.quantity;
    } else {
        item.quantity = 1;
    }

    this.cartService.saveCartToStorage();
    this.updateTotalAmount();
}

  onlyNumbers(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    const inputValue = event.target.value;
    
    if (charCode === 8 || charCode === 9 || charCode === 46 || charCode === 37 || charCode === 39) {
        return true;
    }
    
    if (charCode >= 49 && charCode <= 57) {
        return true;
    }
    
    if (charCode === 48) {
        return inputValue.length > 0 && inputValue !== '0';
    }
    
    return false;
  }

  getCartItemInputById(itemId: number): HTMLInputElement | null {
    const idToFind = `${itemId}`;
    const cartItemElement = this.cartItemElements
      .find(el => el.nativeElement.id === idToFind);
    
    if (!cartItemElement) {
      return null;
    }
  
    const inputElement = cartItemElement.nativeElement.querySelector('input.input-counter');
    return inputElement as HTMLInputElement;
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value).replace(/\$\s+/g, '$');
  }

  goHome(){
    if (this.router.url === '/home') {
      this.cartService.toggleCart();
    } else {
      this.cartService.toggleCart();
      this.router.navigate(['/home']);
    }
  }
}
